import { render, staticRenderFns } from "./RoleEditView.vue?vue&type=template&id=13ceebaa"
import script from "./RoleEditView.vue?vue&type=script&lang=js"
export * from "./RoleEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports